/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/
import React from 'react';
import ItemTitle from './ItemTitle';
import { getUserAgent, isSoleTrader } from '../../../utils'

const soleTraderHiddenContent = [
    "FATCA Declaration for Active Non-Financial Foreign Entitles",
    "SBB ACCOUNT OPENING APPENDIX: ENTITY SELF CERTIFICATION FORM",
    "主动非金融外国实体FATCA声明",
    "小企业银行开户表格附件：机构税收居民身份声明文件"
];

const ReviewDoc = (props) => {
    const { i18n, pdfList, updateFileAction, applicationInfo } = props;
    const _UA = getUserAgent();
    const soleTrader = isSoleTrader(applicationInfo);
    const pContent = i18n.pContent.map((item,index) => {
        return (
            <div className="pdf-checklist" key={index}>
                <div className="title">
                    {item.title}
                </div>
                <ul>
                    {
                        item.content.map((itemContent,idx) => {
                            if (soleTrader && soleTraderHiddenContent.indexOf(itemContent) !== -1) {
                                return null;
                            } else {
                                return (
                                    <li key={idx}>{itemContent}</li>
                                )
                            }
                        })
                    }
                </ul>
            </div>
        )
    });
    return (
        <div>
            <ItemTitle i18n={i18n.reviewDocTitle} />
            {/*<div className={"docList-plz-info"}></div>*/}

            { pContent }
            {
            pdfList.length > 0 &&
            <div className="pdf-form-title" data-key="i18n.formTitle">{i18n.formTitle}</div>
            }
            <ul>
                {
                    pdfList.map((item, index) => {
                        let isDownLoad = item.status === "SAVED";
                        let isloading = item.status === "GENERATED";
                        const isFailed = item.status === "GENERATE_FAILED";
                        let cursorStyle = isDownLoad ? " pdf-downLoad-cursor" : "";
                        let loadingColor = isDownLoad ? "" : " pdf-loading-color";
                        if (_UA.mobile) {
                        isDownLoad = false;
                        loadingColor = '';
                        }

                        return (
                            <li key={index} className={"pdfList-li"}>
                                <div
                                    role={isDownLoad ? "link" : "text"}
                                    aria-label={item.name + "PDF"}
                                    className={cursorStyle}
                                    onClick={isDownLoad ? () => updateFileAction(item.iccmFileNetId) : null}>
                                    <span className={loadingColor} data-key={item.dataKay}>{item.name}</span>
                                    {!_UA.mobile ?
                                    <span data-key={`${item.dataKay}Type`} className={`docList-pdf-type ${loadingColor}`}>
                                        [PDF]{!isFailed && <span>
                                        <i className={`icon icon-chevron-right-small ${loadingColor}`}></i></span>
                                        }
                                    </span>
                                    :
                                    <p data-key="i18n.mobileTips">{i18n.mobileTips}</p>
                                    }
                                </div>

                            {!_UA.mobile && !isFailed &&
                                <div>
                                <span data-key={`${item.dataKay}StatusExplanation`}>{i18n[item.status]}</span>
                                <i className={isloading ? "pdf-loading-icon" : ""}></i>
                                </div>
                            }
                            { isFailed &&
                                <div className="pdf-failed">{i18n.GENERATE_FAILED}</div>
                            }
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
};
ReviewDoc.propTypes = {

};
export default ReviewDoc;





// WEBPACK FOOTER //
// ./src/views/Appointment/components/ReviewDoc.js